import React, { useEffect } from 'react';
import AppRoutes from '@/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import BicesterLayout from './components/layouts/BicesterLayout';
import Helmet from 'react-helmet';

export const __PUBLIC__: string = process.env.PUBLIC_PATH;
function App() {
  const appName = process.env.REACT_APP_NAME;
  
  return (
    <BicesterLayout>
      <BrowserRouter basename={__PUBLIC__}>
        <Helmet titleTemplate={`%s · ${appName}`} defaultTitle={appName} />
        <AppRoutes />
      </BrowserRouter>
    </BicesterLayout>
  );
}

export default App;
